import { Typography, TypographyProps } from '@mui/material';
import { FC } from 'react';
import { NumericFormat } from 'react-number-format';

interface EuroDisplayProps {
  label?: string;
  valueInEuroCent: number;
  captionProps?: TypographyProps;
  displayProps?: TypographyProps;
  suffix?: string;
}

export const EuroDisplay: FC<EuroDisplayProps> = props => {
  return (
    <Typography
      variant="caption"
      sx={{
        color: 'text.secondary',
      }}
    >
      {props.label}
      <Typography
        sx={{
          color: 'text.primary',
        }}
      >
        <NumericFormat
          value={props.valueInEuroCent / 100}
          displayType="text"
          fixedDecimalScale={true}
          decimalScale={2}
          allowLeadingZeros={true}
          decimalSeparator={','}
          suffix={props.suffix ?? ' €/h'}
        />
      </Typography>
    </Typography>
  );
};
